import { queryOptions, useQuery } from '@tanstack/react-query';
import {
  fetchOrganizationEventLog,
  fetchSurveyEventLog,
  transformEventLogEntry,
} from 'services/backend/eventLog';

export const eventLogQueries = {
  all: () => ['eventLog'],
  surveyEventLog: (opts: { surveyId: number }) =>
    queryOptions({
      queryFn: () => fetchSurveyEventLog({ surveyId: opts.surveyId }),
      queryKey: [...eventLogQueries.all(), 'survey', opts.surveyId],
      select: (data) => data.map(transformEventLogEntry),
    }),
  organizationEventLog: (opts: { organizationId: number }) =>
    queryOptions({
      queryFn: () =>
        fetchOrganizationEventLog({ organizationId: opts.organizationId }),
      queryKey: [...eventLogQueries.all(), 'organization', opts.organizationId],
      select: (data) => data.map(transformEventLogEntry),
    }),
};

export function useSurveyEventLog({ surveyId }: { surveyId: number }) {
  return useQuery(eventLogQueries.surveyEventLog({ surveyId }));
}

export function useOrganizationEventLog({
  organizationId,
}: {
  organizationId: number;
}) {
  return useQuery(eventLogQueries.organizationEventLog({ organizationId }));
}
